import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import ReactDOM from 'react-dom'
import { Settings } from './components/Settings'
import { TreeView } from './components/TreeView'
import runtime from 'serviceworker-webpack-plugin/lib/runtime'
import { store, persistor } from './store/configureStore'
import { Loading } from './components/Loading'
import { PageNotFound } from './components/PageNotFound'
import { initControllers } from './controllers'

const App = () => {
    return (
        <Router>
            <PersistGate loading={<Loading />} persistor={persistor}>
                <Switch>
                    <Route component={Settings} exact path="/settings" />
                    <Route component={TreeView} exact path="/" />
                    <Route component={PageNotFound} path="*" />
                </Switch>
            </PersistGate>
        </Router>
    )
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)

initControllers()

if ('serviceWorker' in navigator) {
    runtime.register()
}
